import $ from "jquery";
import "magnific-popup";

export default function openGalleriesModal() {
  $(".module-gallery").each(function () {
    // the containers for all your galleries
    $(this).magnificPopup({
      delegate: "a", // the selector for gallery item
      type: "image",
      gallery: {
        enabled: true,
        tCounter: "%curr% / %total%", // Markup for "1 of 7" counter
      },
    });
  });
}
